<mat-card class="abut">
    <mat-card-header>
        <mat-card-title>Habla con nosotros!</mat-card-title>
        <mat-card-subtitle>Version 1.2.0</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>

        <div>
            <div style="width: 352px; height: 40px;">
                <label style="padding-left: 2px; padding-right: 20px; display: none; margin-bottom: 10px; text-align: left; direction: ltr;"></label>
                <input type="text" required="" placeholder="Nombre" maxlength="100" value="" style="padding-left: 5px;">
                <p id="comp-k026m2cemessage" class="style-k6dwbkjcmessage" style="display: none;"></p>
            </div>
            <div style="width: 352px; height: 40px;">
                <label for="comp-k6g0u0qiinput" id="comp-k6g0u0qilabel" class="style-k6g0u0sglabel"
                    style="padding-left: 2px; padding-right: 20px; display: none; margin-bottom: 10px; text-align: left; direction: ltr;"></label>
                <input type="tel" placeholder="Teléfono" maxlength="50" value="" style="padding-left: 5px;">
                <p id="comp-k6g0u0qimessage" style="display: none;"></p>
            </div>
            <div style="width: 351px; height: 40px;">
                <label style="padding-left: 2px; padding-right: 20px; display: none; margin-bottom: 10px; text-align: left; direction: ltr;"></label>
                <input
                    type="text" placeholder="Apellido" maxlength="100" value="" style="padding-left: 5px;">
                <p style="display: none;"></p>
            </div>
            <div style="width: 351px; height: 40px;"><label for="comp-k026m2d3input" id="comp-k026m2d3label"
                    class="style-k6dwbkjalabel"
                    style="padding-left: 2px; padding-right: 20px; display: none; margin-bottom: 10px; text-align: left; direction: ltr;"></label><input
                    type="email" required="" placeholder="E-mail" pattern="^.+@.+\.[a-zA-Z]{2,63}$" maxlength="250"
                    class="has-custom-focus style-k6dwbkjainput" id="comp-k026m2d3input" value=""
                    style="padding-left: 5px;">
                <p id="comp-k026m2d3message" class="style-k6dwbkjamessage" style="display: none;"></p>
            </div>
            <div style="width: 732px; height: 79px;"><label style="padding-left: 2px; padding-right: 20px; display: none; margin-bottom: 12px; text-align: left; direction: ltr;"></label>
                <textarea placeholder="Escribí tu mensaje aquí..."  style="padding-left: 5px; padding-right: 10px;"></textarea>
                </div>
            <div style="width: 234px; height: 60px;">
                <div>
                    
                </div>
            </div>
            <div style="cursor: pointer; height: 51px; min-height: 21px; width: 256px;">
                <button style="cursor: pointer;"><span>Enviar</span></button>
            </div>
            <div style="width: 510px; pointer-events: none; visibility: hidden;">
                <p class="font_9" style="text-align:center;">
                    <span style="color:#FFFFFF;">¡Gracias por tumensaje!&nbsp;</span>
                </p>
            </div>
        </div>

    </mat-card-content>
    <mat-card-footer>

    </mat-card-footer>
</mat-card>